import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import EditAlbum from '../components/EditAlbum';
import Album from '../models/Album';

const translationPrefix = 'kilowhat-cimaise.forum.new-album-modal.';

interface NewAlbumModalAttrs extends IInternalModalAttrs {
    album: Album
    onsave: (album: Album) => void
}

export default class NewAlbumModal extends Modal<NewAlbumModalAttrs> {
    className() {
        return 'Modal--small';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title');
    }

    content() {
        return m('.Modal-body', m(EditAlbum, {
            onsave: (album: Album) => {
                this.hide();
                this.attrs.onsave(album);
            },
        }));
    }
}
